import { render, staticRenderFns } from "./edit-baseCard.vue?vue&type=template&id=1493f7d3&scoped=true"
import script from "./edit-baseCard.vue?vue&type=script&lang=ts"
export * from "./edit-baseCard.vue?vue&type=script&lang=ts"
import style0 from "./edit-baseCard.vue?vue&type=style&index=0&id=1493f7d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1493f7d3",
  null
  
)

export default component.exports